import { api, type CandidateDetailView } from '../../lib/client.ts';
import { PipelinePlaces } from '../pipelines/pipeline-places.tsx';

const nameOf = (c: CandidateDetailView) =>
  [c.firstName, c.lastName].filter(Boolean).join(' ') || c.email || 'this candidate';

/**
 * The candidate's Pipelines card: its places in Candidate Flow pipelines, as a project has
 * them (the shared `PipelinePlaces`). Every new candidate starts in the default pipeline, whose
 * stage is the candidate's `stage`; a move in another pipeline leaves it alone. A candidate from
 * before places may be in none: then the card shows only to someone who can add it to one.
 */
export function CandidatePipelines({
  candidate,
  canWrite,
  onChanged,
}: {
  candidate: CandidateDetailView;
  canWrite: boolean;
  onChanged: () => Promise<void>;
}) {
  if (candidate.pipelines.length === 0 && !canWrite) return null;
  return (
    <PipelinePlaces
      type="candidate"
      recordName={nameOf(candidate)}
      places={candidate.pipelines}
      canWrite={canWrite}
      onChanged={onChanged}
      testId="candidate-pipelines"
      placeTestId="candidate-pipeline"
      actions={{
        move: (stageId) => api.candidates.patch(candidate.id, { stageId }),
        setArchived: (pipelineId, archived) =>
          archived
            ? api.candidates.archiveInPipeline(candidate.id, pipelineId)
            : api.candidates.restoreInPipeline(candidate.id, pipelineId),
        add: (body) => api.candidates.addToPipeline(candidate.id, body),
      }}
    />
  );
}
